import { MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';

export const config = {
    id: ActionType.DIGITAL_CONTENT_DESENSITIZATION,
    content: i18n.t('数字内容脱敏'),
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
    },
];
